import { VersionLanguageModel, VersionModel } from '@partful/instructions-domain-models';
import { Badge } from '@partful/shared/ui/Badge';
import { Option, Select } from '@partful/shared/ui/Select';
import { Typography } from '@partful/shared/ui/Typography';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './SegmentEditor.module.scss';
import { SegmentsList } from './SegmentsList/SegmentsList';

type SegmentsEditorProps = {
  version: VersionModel;
  versionLanguages: VersionLanguageModel[];
};

export function SegmentsEditor({ version, versionLanguages }: SegmentsEditorProps) {
  const { t: i18n } = useTranslation();
  const [selectedLanguage] = useState(versionLanguages.find((language) => language.isDefault)?.languageCode);

  return (
    <div className={styles.editor}>
      <div className={styles.language}>
        <Typography fontWeight={600}>{i18n('instructions:manage.version.instructions.language')}</Typography>
        <div className={styles.selection}>
          <Select className={styles.select} size="medium" data-testid="selectLanguage" value={selectedLanguage}>
            {versionLanguages?.map((versionLanguage) => (
              <Option key={versionLanguage.languageCode} value={versionLanguage.languageCode}>
                {i18n(`languageNames:${versionLanguage.languageCode}`)}
              </Option>
            ))}
          </Select>
          <Badge variant="default">{i18n('instructions:common.status.draft')}</Badge>
          <Badge variant="neutral">{i18n('instructions:common.default')}</Badge>
        </div>
      </div>
      <div className={styles.segments}>
        <Typography fontWeight={600}>{i18n('instructions:manage.version.segments.segments')}</Typography>
        {selectedLanguage && <SegmentsList version={version} languageCode={selectedLanguage} />}
      </div>
    </div>
  );
}
